import { render } from "./AttachPhoto.vue?vue&type=template&id=ccb7f298"
import script from "./AttachPhoto.vue?vue&type=script&lang=js"
export * from "./AttachPhoto.vue?vue&type=script&lang=js"

import exportComponent from "C:\\jhj\\applemarket\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__